import { render, staticRenderFns } from "./noProductSelected.vue?vue&type=template&id=67b0f3b6&scoped=true&"
import script from "./noProductSelected.vue?vue&type=script&lang=js&"
export * from "./noProductSelected.vue?vue&type=script&lang=js&"
import style0 from "./noProductSelected.vue?vue&type=style&index=0&id=67b0f3b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b0f3b6",
  null
  
)

export default component.exports